/**
 * ModuleHeader.jsx
 * Header minimalista y limpio para módulos
 * Inspirado en el Panel de Auditoría - Sin breadcrumbs, con tooltip para descripción
 */

import React from 'react';
import {
  Card,
  Space,
  Typography,
  Tooltip,
  Divider
} from '@arco-design/web-react';
import { IconInfoCircle } from '@arco-design/web-react/icon';

const { Title, Text } = Typography;

/**
 * Header minimalista para módulos
 * @param {Object} props
 * @param {string} props.title - Título del módulo
 * @param {string} props.description - Descripción (se muestra en tooltip)
 * @param {React.ReactNode} props.stats - Tags de estadísticas (se muestran junto al título)
 * @param {React.ReactNode} props.actions - Botones o acciones a la derecha
 * @param {React.ReactNode} props.children - Contenido debajo del divider (búsqueda, filtros, etc.)
 * @param {boolean} props.showDivider - Si mostrar divisor debajo (default: true)
 * @param {boolean} props.inCard - Si está dentro de un Card (default: false)
 */
const ModuleHeader = ({
  title,
  description,
  stats,
  actions,
  children,
  showDivider = true,
  inCard = false
}) => {
  const headerContent = (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: showDivider ? 0 : 8
      }}>
        <Space size="medium">
          <Title heading={5} style={{ margin: 0 }}>{title}</Title>
          {description && (
            <Tooltip content={description} position="right">
              <IconInfoCircle style={{
                fontSize: 14,
                color: 'var(--color-text-3)',
                cursor: 'help'
              }} />
            </Tooltip>
          )}
          {stats}
        </Space>
        {actions && (
          <Space>{actions}</Space>
        )}
      </div>
      {showDivider && <Divider style={{ margin: '8px 0' }} />}
      {children}
    </>
  );

  // Si ya está dentro de un Card, no envolver en otro
  if (inCard) {
    return headerContent;
  }

  // Si no está en un Card, crear uno con padding reducido
  return (
    <Card
      style={{ marginBottom: 8 }}
      bodyStyle={{ padding: '12px 20px' }}
    >
      {headerContent}
    </Card>
  );
};

export default ModuleHeader;